import { BrowserRouter, Routes, Route } from 'react-router-dom';
// import { HashRouter, Routes, Route } from 'react-router-dom';
import Header from './components/Header/header';
import Footer from './components/Footer/footer';
import Home from './components/Pages/Home/Homes';
import About from './components/Pages/About/About';
import Reviews from './components/Pages/Review/Reviews';
import Servicedetail from './components/Pages/ServiceDetail/Servicedetail';
import Blog from './components/Pages/Blog/Blog';
import StaffAugmentation from './components/Pages/Staff_Augmention/StaffAugmentation'
import Contact from './components/Pages/Contact/Contact';
import Events from './components/Pages/Events/Events';
import Careers from './components/Pages/Careers/Careers';
import Project from './components/Pages/Project_All/Project';
import Dakzy from './components/Pages/ProjectDetail/Dakzy';
import Fot from './components/Pages/ProjectDetail/Fot';
import Myacebazar from './components/Pages/ProjectDetail/Myacebazar';
import Mypocketnotres from './components/Pages/ProjectDetail/Mypocketnotres';
import Girlsslay from './components/Pages/ProjectDetail/Girlsslay';
import Anthlete from './components/Pages/ProjectDetail/Anthlete';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import ScrollToTop from './ScrollToTop';
import React from 'react';
import { TweenLite, Circ } from 'gsap';
import GlobalAnimatedBackground from './components/GlobalAnimatedBackground';
 

function App() {
  return (
    <>
      <video
        autoPlay
        loop
        muted
        playsInline
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          objectFit: "cover",
          zIndex: -100,
          pointerEvents: "none"
        }}
      >
        <source src={require("./img/background/new-background.mp4")} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
      <GlobalAnimatedBackground />
      <BrowserRouter >
        <Header />
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/reviews" element={<Reviews />} />
          <Route path="/servicedetail" element={<Servicedetail />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/staffaugmentation" element={<StaffAugmentation />} />
          <Route path="/contact" element={<Contact />} /> 
         {/* <Route path="/staff-augmentation" element={<StaffAugmentation />} />  */}
         <Route path="/events" element={<Events />} />
         <Route path="/careers" element={<Careers />} />
         <Route path="/projects" element={<Project />} />
         <Route path="/dakzy" element={<Dakzy />} />
          <Route path="/fot" element={<Fot />} />
          <Route path="/myacebazar" element={<Myacebazar />} />
          <Route path="/mypocketnotres" element={<Mypocketnotres />} />
          <Route path="/girlsslay" element={<Girlsslay />} />
          <Route path="/anthlete" element={<Anthlete />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </>
  );
}

export default App;
